function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { withContext } from 'recompose';
import request from 'superagent';
import articleUtil from '../utils/article';
var articleModuleContext = {
  adaptiveUrl: undefined,
  sources: undefined,
  enableArticleComments: undefined,
  enableSearch: undefined,
  recaptchaSiteKey: undefined
};
var nextMapId = 0;

var ArticleModule = function (_React$Component) {
  _inherits(ArticleModule, _React$Component);

  function ArticleModule() {
    _classCallCheck(this, ArticleModule);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.id = 'react-article-module-' + ++nextMapId;
    _this.state = {
      configLoaded: false
    };
    return _this;
  }

  ArticleModule.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        sources = _props.sources,
        articleModuleUuid = _props.articleModuleUuid,
        adaptiveUrl = _props.adaptiveUrl,
        enableSearch = _props.enableSearch,
        enableArticleComments = _props.enableArticleComments,
        recaptchaSiteKey = _props.recaptchaSiteKey;
    articleModuleContext.adaptiveUrl = adaptiveUrl;

    if (!sources && !articleModuleUuid) {
      throw new Error('Missing props, sources or articleModuleUuid is required');
    }

    if (sources) {
      articleModuleContext.sources = sources;
      articleModuleContext.enableSearch = enableSearch;
      articleModuleContext.enableArticleComments = enableArticleComments;
      articleModuleContext.recaptchaSiteKey = recaptchaSiteKey;
      articleUtil.init(adaptiveUrl, sources, recaptchaSiteKey);
      this.initSearchSession();
      this.setState({
        configLoaded: true
      });
    }

    if (articleModuleUuid && !this.state.configLoaded) {
      this.loadArticleModuleConfig();
    }
  };

  ArticleModule.prototype.loadArticleModuleConfig = function loadArticleModuleConfig() {
    var _this2 = this;

    var articleModuleUuid = this.props.articleModuleUuid;
    request.post(articleModuleContext.adaptiveUrl + 'WebServices/articleModule/ArticleModuleConfig.asmx/ReadArticleModuleConfig').set('Accept', 'application/json').set('Content-Type', 'application/json').send({
      amuuid: articleModuleUuid
    }).then(function (res) {
      return res.body;
    }).then(function (res) {
      Object.assign(articleModuleContext, res);
      articleUtil.init(articleModuleContext.adaptiveUrl, res.sources, articleModuleContext.recaptchaSiteKey);

      _this2.initSearchSession();

      _this2.setState({
        configLoaded: true
      });
    }).catch(function (e) {
      console.error('Load theme/digitheme article failed', e);
      throw new Error('Failed to load article module config');
    });
  };

  ArticleModule.prototype.initSearchSession = function initSearchSession() {
    var onSearchInit = this.props.onSearchInit;

    if (articleModuleContext.enableSearch) {
      onSearchInit(articleUtil.initSearch());
    }
  };

  ArticleModule.prototype.render = function render() {
    return React.createElement('div', null, React.createElement('div', {
      id: this.id,
      className: 'react-article-module'
    }, articleModuleContext.sources && this.props.children));
  };

  return ArticleModule;
}(React.Component);

ArticleModule.propTypes = process.env.NODE_ENV !== "production" ? {
  adaptiveUrl: PropTypes.string.isRequired,
  sources: PropTypes.array,
  articleModuleUuid: PropTypes.string,
  enableArticleComments: PropTypes.bool,
  enableSearch: PropTypes.bool,
  recaptchaSiteKey: PropTypes.string,
  onSearchInit: PropTypes.func,
  children: PropTypes.node
} : {};

var ensureArticleModuleConfig = function ensureArticleModuleConfig() {
  return withContext({
    articleModuleContext: PropTypes.object
  }, function () {
    return {
      articleModuleContext: articleModuleContext
    };
  });
};

export default ensureArticleModuleConfig()(ArticleModule);